import React, { createContext, useState } from 'react';

export const ThemeContext = createContext();

export function ThemeContextProvider(props) {
  const [themeName, setThemeName] = useState(() => {
    const savedTheme = window.localStorage.getItem('appTheme');
    if (savedTheme === 'bauhaus' || savedTheme === 'kinetic') {
      return savedTheme;
    }
    return 'bauhaus';
  });

  const toggleTheme = () => {
    const newTheme = themeName === 'bauhaus' ? 'kinetic' : 'bauhaus';
    setThemeName(newTheme);
    window.localStorage.setItem('appTheme', newTheme);
  };

  const changeTheme = (newTheme) => {
    if (newTheme === 'bauhaus' || newTheme === 'kinetic') {
      setThemeName(newTheme);
      window.localStorage.setItem('appTheme', newTheme);
    }
  };

  return (
    <ThemeContext.Provider value={{ themeName, toggleTheme, changeTheme }}>
      {props.children}
    </ThemeContext.Provider>
  );
}
